import { dateFns as moment } from '@pcln/date-fns-utils'

const FOUR_AM = 4

export const getCheckInDateFromArrival = (travelDate, slices) => {
  let checkInDate = travelDate
  if (slices?.[0]?.willArriveOnDiffDate) {
    const arrivalTime = new Date(slices?.[0]?.arrivalInfo?.time?.dateTime)
    const fourAM = new Date(arrivalTime)
    fourAM.setHours(FOUR_AM, 0, 0, 0)
    const isPast4AM = arrivalTime.getTime() > fourAM.getTime()
    checkInDate = isPast4AM ? moment(arrivalTime).format('YYYY-MM-DD') : checkInDate
  }
  return checkInDate
}
